'use client';

import Image from 'next/image';
import { Icon } from '@/components/entities/Sprite';
import { useCampaignLogo } from '@/components/features/campaigns';
import { cn } from '@/utils/cn';

const DEFAULT_LOGO_ICONS = {
  desktop: 'desktop-logo',
  mobile: 'mobile-logo',
} as const;

type SiteLogoLayout = keyof typeof DEFAULT_LOGO_ICONS;

const CAMPAIGN_LOGO_SIZES = {
  desktop: '230px',
  mobile: '48px',
} as const satisfies Record<SiteLogoLayout, string>;

interface Props {
  layout: SiteLogoLayout;
  className?: string;
  priority?: boolean;
}

export const SiteLogo = ({ layout, className, priority }: Props) => {
  const campaignLogo = useCampaignLogo();

  if (!campaignLogo) {
    return <Icon name={DEFAULT_LOGO_ICONS[layout]} className={className} />;
  }

  return (
    <Image
      src={campaignLogo[layout]}
      alt={campaignLogo.alt}
      sizes={CAMPAIGN_LOGO_SIZES[layout]}
      priority={priority}
      className={cn('object-contain', className)}
      style={{ width: 'auto' }}
    />
  );
};
